// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-green: #82B194;
  --bw-green-hover: #739F84;
  --bw-green-dark: #5C826C;
  --bw-card: #F7F5F1;
  --bw-card-soft: #F8F6F2;
  --bw-page: #EFF0EC;
  --bw-surface: #F7F5F1;
  --bw-border: rgba(16, 25, 21, 0.10);
  --bw-ink: #13231D;
  --bw-muted: rgba(19, 35, 29, 0.68);
  --bw-radius-lg: 28px;
  --bw-radius-md: 18px;
  --bw-shadow: 0 22px 60px rgba(16, 39, 31, 0.18);
}

.bw-photo-editor,
.bw-photo-editor *,
.bw-photo-modal,
.bw-photo-modal * {
  box-sizing: border-box;
  font-style: normal;
}

.bw-photo-editor__shell {
  background: var(--bw-card-soft);
  border: 1px solid var(--bw-border);
  border-radius: var(--bw-radius-lg);
  box-shadow: 0 18px 48px rgba(16, 39, 31, 0.08);
  padding: clamp(18px, 3vw, 32px);
}

.bw-photo-editor__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 18px;
}

.bw-photo-editor__eyebrow,
.bw-photo-modal__eyebrow {
  margin: 0 0 6px;
  color: var(--bw-green);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.bw-photo-editor__header h2 {
  margin: 0;
  font-size: clamp(28px, 4vw, 44px);
  line-height: 1;
  letter-spacing: -0.05em;
}

.bw-photo-editor__saved {
  border: 1px solid rgba(130, 177, 148, 0.30);
  color: var(--bw-green-dark);
  background: rgba(130, 177, 148, 0.12);
  padding: 8px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
}

.bw-photo-editor__cover {
  position: relative;
  overflow: hidden;
  aspect-ratio: 16 / 7;
  border-radius: 28px;
  border: 1px solid var(--bw-border);
  background: #EFF0EC;
  min-height: 240px;
}

.bw-photo-editor__cover img,
.bw-photo-editor__placeholder,
.bw-review-profile img,
.bw-review-card img,
.bw-photo-editor__card-frame img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.bw-photo-editor__placeholder {
  display: grid;
  place-items: center;
  color: var(--bw-muted);
  background:
    radial-gradient(circle at center, rgba(130, 177, 148, 0.14), transparent 45%),
    #EFF0EC;
}

.bw-photo-editor__cover-cta {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid rgba(16, 39, 31, 0.15);
  color: var(--bw-ink);
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(8px);
  border-radius: 999px;
  min-height: 44px;
  padding: 0 18px;
  font-size: 14px;
  font-weight: 800;
  box-shadow: 0 14px 28px rgba(16, 39, 31, 0.12);
}

.bw-photo-editor__content-grid {
  display: grid;
  grid-template-columns: 1fr minmax(220px, 280px);
  gap: 18px;
  margin-top: 18px;
}

.bw-photo-editor__card-preview,
.bw-photo-editor__notes {
  background: var(--bw-card);
  border: 1px solid var(--bw-border);
  border-radius: 22px;
  padding: 18px;
}

.bw-photo-editor__card-preview h3,
.bw-photo-editor__notes h3 {
  margin: 0 0 12px;
  font-size: 16px;
}

.bw-photo-editor__card-frame {
  width: min(180px, 100%);
  aspect-ratio: 4 / 5;
  border-radius: 18px;
  overflow: hidden;
  border: 1px solid var(--bw-border);
  background: #EFF0EC;
  display: grid;
  place-items: center;
  color: var(--bw-muted);
  font-size: 13px;
}

.bw-photo-editor__notes p {
  margin: 0;
  color: var(--bw-muted);
  line-height: 1.65;
  font-size: 14px;
}

.bw-photo-editor__notes code {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  background: rgba(130, 177, 148, 0.12);
  padding: 2px 5px;
  border-radius: 6px;
  color: var(--bw-green-dark);
}

.bw-photo-modal {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: grid;
  place-items: center;
  padding: 24px;
}

.bw-photo-modal__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(16, 39, 31, 0.48);
}

.bw-photo-modal__panel {
  position: relative;
  width: min(960px, 100%);
  max-height: min(828px, calc(100vh - 48px));
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 30px;
  background: var(--bw-card-soft);
  border: 1px solid rgba(255, 255, 255, 0.28);
  box-shadow: var(--bw-shadow);
}

.bw-photo-modal__close {
  position: absolute;
  top: 16px;
  right: 18px;
  z-index: 4;
  min-height: 38px;
  padding: 0 15px;
  border-radius: 16px;
  border: 1px solid rgba(16, 39, 31, 0.13);
  background: rgba(255, 255, 255, 0.72);
  color: var(--bw-ink);
  font-size: 13px;
  font-weight: 800;
}

.bw-photo-modal__steps {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 18px 116px 12px 24px;
  border-bottom: 1px solid rgba(16, 39, 31, 0.08);
}

.bw-photo-modal__steps li {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: rgba(16, 39, 31, 0.56);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.bw-photo-modal__steps span {
  width: 24px;
  height: 24px;
  flex: 0 0 24px;
  display: grid;
  place-items: center;
  border-radius: 999px;
  background: rgba(16, 39, 31, 0.08);
  color: rgba(16, 39, 31, 0.64);
  font-size: 11px;
}

.bw-photo-modal__steps li.is-active {
  color: var(--bw-green-dark);
}

.bw-photo-modal__steps li.is-active span {
  background: var(--bw-green);
  color: #fff;
}

.bw-photo-modal__body {
  flex: 1 1;
  overflow-y: auto;
  padding: 18px 24px 12px;
}

@media (min-width: 761px) {

  .bw-photo-modal__body--upload,
  .bw-photo-modal__body--profile,
  .bw-photo-modal__body--card,
  .bw-photo-modal__body--review {
    overflow: hidden;
  }
}

.bw-photo-modal__step-copy {
  max-width: 820px;
  padding-right: 118px;
  margin-bottom: 14px;
}

.bw-photo-modal__step-copy--compact {
  margin-bottom: 12px;
}

.bw-photo-modal__step-copy p {
  margin: 0 0 6px;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  font-size: 12px;
  font-weight: 800;
  color: var(--bw-green);
}

.bw-photo-modal__step-copy h3,
.bw-photo-modal__upload-panel h3 {
  margin: 0 0 8px;
  font-size: clamp(24px, 3vw, 32px);
  line-height: 1.02;
  letter-spacing: -0.05em;
}

.bw-photo-modal__step-copy span,
.bw-photo-modal__upload-panel span {
  display: block;
  color: var(--bw-muted);
  font-size: 16px;
  line-height: 1.45;
}

.bw-photo-modal__step-copy span {
  max-width: 760px;
}

.bw-photo-modal__upload-panel span {
  max-width: 620px;
  margin: 0 auto;
}

.bw-photo-modal__upload-panel {
  min-height: 360px;
  display: grid;
  place-items: center;
  gap: 22px;
  text-align: center;
  padding: 28px;
  border: 1px dashed rgba(16, 39, 31, 0.18);
  border-radius: 24px;
  background:
    radial-gradient(circle at center, rgba(130, 177, 148, 0.14), transparent 48%),
    rgba(255, 255, 255, 0.36);
}

.bw-cropper-shell {
  position: relative;
  width: 100%;
  border-radius: 24px;
  overflow: hidden;
  background: var(--bw-ink, #13231D);
  border: 1px solid rgba(16, 39, 31, 0.12);
}

.bw-cropper-shell--profile {
  width: min(100%, 900px);
  margin: 0 auto;
  aspect-ratio: 16 / 7;
  min-height: 0;
}

.bw-card-crop-layout {
  display: grid;
  grid-template-columns: 1fr 250px;
  gap: 18px;
  align-items: stretch;
}

.bw-cropper-shell--card {
  width: 250px;
  justify-self: end;
  aspect-ratio: 4 / 5;
  min-height: 0;
}

.bw-card-crop-note {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  min-height: 0;
  padding: 20px;
  border-radius: 22px;
  border: 1px solid rgba(16, 39, 31, 0.1);
  background: var(--bw-card);
}

.bw-card-crop-note strong {
  color: var(--bw-green-dark);
  font-size: 15px;
}

.bw-card-crop-note p {
  margin: 0;
  max-width: 420px;
  color: var(--bw-muted);
  font-size: 14px;
  line-height: 1.55;
}

.bw-link-btn {
  width: fit-content;
  margin-top: 4px;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--bw-green-dark);
  font: inherit;
  font-size: 14px;
  font-weight: 800;
  text-decoration: underline;
  text-underline-offset: 4px;
}

/*
  Clave de implementación:
  react-easy-crop debe trabajar en modo cover. Si en staging se ve la foto centrada con laterales vacíos,
  revisar si el componente quedó con objectFit="contain" o si el contenedor/previews usan object-fit: contain.
*/
.bw-cropper-shell .reactEasyCrop_Image,
.bw-cropper-shell .reactEasyCrop_Video {
  object-fit: cover !important;
}

/* Ajuste v14: el área de recorte coincide con el contenedor.
   Se oculta el borde interno de react-easy-crop para evitar una línea lateral que parece error visual. */
.bw-cropper-shell .reactEasyCrop_CropArea {
  border: 0 !important;
  box-shadow: none !important;
  color: transparent !important;
}

.bw-cropper-shell .reactEasyCrop_Container {
  border-radius: inherit;
  overflow: hidden;
}

.bw-photo-modal__slider {
  display: grid;
  gap: 5px;
  margin: 10px 0 0;
  color: var(--bw-ink);
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
  text-align: center;
}

.bw-photo-modal__slider--card {
  margin-top: 8px;
}

.bw-photo-modal__slider span {
  display: block;
  line-height: 1;
}

/*
  Slider de zoom:
  El control debe usar verde primary #82B194 y nunca el azul nativo del navegador.
  No se dibuja progreso con linear-gradient para evitar una segunda barra visual.
*/
.bw-photo-modal__slider input {
  width: 100%;
  height: 22px;
  appearance: none;
  -webkit-appearance: none;
  border-radius: 999px;
  background: transparent;
  outline: none;
  accent-color: var(--bw-green);
  cursor: pointer;
}

.bw-photo-modal__slider input::-webkit-slider-runnable-track {
  height: 5px;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.34);
  border: 1px solid rgba(130, 177, 148, 0.24);
}

.bw-photo-modal__slider input::-webkit-slider-thumb {
  appearance: none;
  -webkit-appearance: none;
  width: 16px;
  height: 16px;
  margin-top: -6.5px;
  border-radius: 999px;
  border: 2px solid var(--bw-surface);
  background: var(--bw-green);
  box-shadow: 0 6px 14px rgba(19, 35, 29, 0.18);
}

.bw-photo-modal__slider input::-moz-range-track {
  height: 5px;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.34);
  border: 1px solid rgba(130, 177, 148, 0.24);
}

.bw-photo-modal__slider input::-moz-range-progress {
  height: 5px;
  border-radius: 999px;
  background: rgba(130, 177, 148, 0.34);
}

.bw-photo-modal__slider input::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: 2px solid var(--bw-surface);
  background: var(--bw-green);
  box-shadow: 0 6px 14px rgba(19, 35, 29, 0.18);
}

.bw-photo-modal__slider input:focus-visible::-webkit-slider-thumb {
  outline: 3px solid rgba(130, 177, 148, 0.28);
  outline-offset: 2px;
}

.bw-photo-modal__slider input:focus-visible::-moz-range-thumb {
  outline: 3px solid rgba(130, 177, 148, 0.28);
  outline-offset: 2px;
}

.bw-photo-modal__review-grid {
  display: grid;
  grid-template-columns: 1.25fr 0.75fr;
  gap: 18px;
  align-items: start;
}

.bw-photo-modal__review-grid article {
  background: var(--bw-card);
  border: 1px solid var(--bw-border);
  border-radius: 22px;
  padding: 16px;
}

.bw-photo-modal__review-grid h4 {
  margin: 0 0 12px;
  font-size: 14px;
  text-align: center;
}

.bw-review-profile,
.bw-review-card {
  overflow: hidden;
  border-radius: 16px;
  background: #EFF0EC;
  border: 1px solid var(--bw-border);
}

.bw-review-profile {
  aspect-ratio: 16 / 7;
}

.bw-review-card {
  width: min(230px, 100%);
  margin: 0 auto;
  aspect-ratio: 4 / 5;
}

.bw-photo-modal__error {
  margin: 10px 0 0;
  color: #8d332b;
  background: rgba(141, 51, 43, 0.08);
  border: 1px solid rgba(141, 51, 43, 0.18);
  padding: 10px 12px;
  border-radius: 14px;
  font-size: 14px;
  font-weight: 700;
}

.bw-photo-modal__footer {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 24px 12px;
  border-top: 1px solid rgba(16, 39, 31, 0.08);
  background: rgba(248, 246, 242, 0.94);
}

.bw-photo-modal__footer--card {
  justify-content: space-between;
}

.bw-btn {
  min-height: 44px;
  border-radius: 16px;
  padding: 0 20px;
  border: 1px solid transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 800;
  white-space: nowrap;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease;
}

.bw-btn:active {
  transform: translateY(1px);
}

.bw-btn--primary {
  color: #fff;
  background: var(--bw-green);
  border-color: var(--bw-green);
  box-shadow: 0 12px 20px rgba(130, 177, 148, 0.24);
}

.bw-btn--primary:hover {
  background: var(--bw-green-hover);
}

.bw-btn--primary:disabled {
  opacity: 0.65;
  cursor: wait;
}

.bw-btn--secondary {
  color: var(--bw-ink);
  background: rgba(255, 255, 255, 0.72);
  border-color: rgba(16, 39, 31, 0.14);
  box-shadow: 0 8px 18px rgba(16, 39, 31, 0.05);
}

.bw-btn--secondary:hover {
  background: rgba(255, 255, 255, 0.92);
  border-color: rgba(130, 177, 148, 0.36);
}

.bw-btn:focus-visible,
.bw-photo-modal__close:focus-visible,
.bw-photo-editor__cover-cta:focus-visible {
  outline: 3px solid rgba(130, 177, 148, 0.32);
  outline-offset: 2px;
}

@media (max-height: 900px) and (min-width: 761px) {
  .bw-photo-modal__panel {
    max-height: calc(100vh - 48px);
  }

  .bw-photo-modal__steps {
    padding-top: 14px;
    padding-bottom: 10px;
  }

  .bw-photo-modal__body {
    padding-top: 16px;
    padding-bottom: 12px;
  }

  .bw-cropper-shell--profile {
    width: min(100%, 860px);
  }

  .bw-card-crop-layout {
    grid-template-columns: 1fr 230px;
  }

  .bw-cropper-shell--card {
    width: 230px;
  }

  .bw-photo-modal__footer {
    padding-top: 12px;
    padding-bottom: 14px;
  }
}

@media (max-width: 760px) {

  .bw-photo-editor__content-grid,
  .bw-photo-modal__review-grid,
  .bw-card-crop-layout {
    grid-template-columns: 1fr;
  }

  .bw-photo-editor__cover {
    min-height: 180px;
    border-radius: 22px;
  }

  .bw-photo-modal {
    padding: 10px;
    align-items: stretch;
  }

  .bw-photo-modal__panel {
    max-height: calc(100vh - 20px);
    border-radius: 24px;
  }

  .bw-photo-modal__steps {
    grid-template-columns: repeat(2, 1fr);
    padding: 14px 82px 12px 14px;
  }

  .bw-photo-modal__steps li {
    font-size: 11px;
  }

  .bw-photo-modal__body {
    overflow-y: auto;
    padding: 18px 14px 14px;
  }

  .bw-photo-modal__close {
    top: 12px;
    right: 12px;
    min-height: 40px;
    padding: 0 14px;
  }

  .bw-photo-modal__step-copy {
    padding-right: 0;
  }

  .bw-photo-modal__step-copy span,
  .bw-photo-modal__upload-panel span {
    font-size: 15px;
  }

  .bw-photo-modal__upload-panel {
    min-height: 420px;
    padding: 22px;
  }

  .bw-cropper-shell--profile {
    width: 100%;
    aspect-ratio: 16 / 7;
    min-height: 0;
    border-radius: 18px;
  }

  .bw-cropper-shell--card {
    width: min(360px, 100%);
    margin: 0 auto;
    max-height: none;
    border-radius: 22px;
  }

  .bw-card-crop-note {
    padding: 14px;
  }

  .bw-photo-modal__slider {
    margin-top: 18px;
    margin-bottom: 8px;
    gap: 12px;
  }

  .bw-photo-modal__slider input {
    min-height: 32px;
  }

  .bw-photo-modal__footer {
    flex-direction: column;
    padding: 14px;
  }

  .bw-photo-modal__footer .bw-btn {
    width: 100%;
  }

  .bw-photo-modal__footer--card .bw-btn:nth-child(1) {
    order: 1;
  }

  .bw-photo-modal__footer--card .bw-btn:nth-child(2) {
    order: 2;
  }

  .bw-photo-modal__footer--card .bw-btn:nth-child(3) {
    order: 3;
  }
}


@media (min-width: 761px) {
  .bw-photo-editor__notes {
    order: 1;
  }

  .bw-photo-editor__card-preview {
    order: 2;
  }
}

/* v7 · Ajuste de lectura y respiración del popup */
.bw-photo-modal__panel {
  width: min(980px, 100%);
  max-height: min(820px, calc(100vh - 48px));
  background: var(--bw-card-soft);
}

.bw-photo-modal__body {
  padding: 30px 28px 18px;
}

.bw-photo-modal__body--upload {
  padding: 22px;
}

.bw-photo-modal__step-copy {
  max-width: 780px;
  padding-right: 124px;
  margin-bottom: 22px;
}

.bw-photo-modal__step-copy--compact {
  margin-bottom: 18px;
}

.bw-photo-modal__step-copy p {
  margin-bottom: 8px;
  color: var(--bw-green);
}

.bw-photo-modal__step-copy h3,
.bw-photo-modal__upload-panel h3 {
  margin-bottom: 12px;
  font-size: clamp(26px, 2.6vw, 34px);
  line-height: 1.06;
}

.bw-photo-modal__step-copy span,
.bw-photo-modal__upload-panel span {
  max-width: 720px;
  font-size: 15px;
  line-height: 1.65;
}

.bw-photo-modal__upload-panel {
  min-height: 430px;
  gap: 30px;
  padding: 34px 36px;
}

.bw-photo-modal__upload-panel span {
  max-width: 680px;
}

.bw-cropper-shell--profile {
  width: min(100%, 840px);
}

.bw-card-crop-layout {
  grid-template-columns: minmax(0, 1fr) 225px;
  gap: 22px;
  align-items: center;
}

.bw-cropper-shell--card {
  width: 225px;
}

.bw-card-crop-note {
  justify-content: center;
  padding: 22px 24px;
}

.bw-card-crop-note p {
  max-width: 500px;
  line-height: 1.65;
}

.bw-photo-modal__slider {
  margin-top: 16px;
  gap: 10px;
}

.bw-photo-modal__slider--card {
  margin-top: 14px;
}

.bw-photo-modal__footer {
  padding: 12px 28px 14px;
}

@media (max-height: 900px) and (min-width: 761px) {
  .bw-photo-modal__body {
    padding-top: 24px;
    padding-bottom: 14px;
  }

  .bw-photo-modal__step-copy {
    margin-bottom: 18px;
  }

  .bw-photo-modal__step-copy h3,
  .bw-photo-modal__upload-panel h3 {
    font-size: 29px;
  }

  .bw-photo-modal__step-copy span,
  .bw-photo-modal__upload-panel span {
    font-size: 14.5px;
    line-height: 1.58;
  }

  .bw-cropper-shell--profile {
    width: min(100%, 820px);
  }

  .bw-card-crop-layout {
    grid-template-columns: minmax(0, 1fr) 215px;
  }

  .bw-cropper-shell--card {
    width: 215px;
  }

  .bw-photo-modal__slider {
    margin-top: 12px;
  }
}

@media (max-width: 760px) {

  .bw-photo-modal__body,
  .bw-photo-modal__body--upload {
    padding: 18px 14px 14px;
  }

  .bw-photo-modal__step-copy {
    padding-right: 0;
    margin-bottom: 18px;
  }

  .bw-photo-modal__step-copy h3,
  .bw-photo-modal__upload-panel h3 {
    font-size: 25px;
  }

  .bw-photo-modal__step-copy span,
  .bw-photo-modal__upload-panel span {
    font-size: 15px;
    line-height: 1.55;
  }

  .bw-card-crop-layout {
    gap: 14px;
  }
}

/* v11 · Dos modos de entrada: portada pública y foto/tarjeta */
.bw-photo-editor__two-areas {
  display: grid;
  grid-template-columns: 250px minmax(0, 1fr);
  gap: 24px;
  align-items: start;
}

.bw-photo-editor__profile-photo-card,
.bw-photo-editor__cover-card,
.bw-photo-editor__notes--full {
  background: var(--bw-card);
  border: 1px solid var(--bw-border);
  border-radius: 28px;
  padding: 22px;
}

.bw-photo-editor__profile-photo-card h3,
.bw-photo-editor__cover-card h3,
.bw-photo-editor__notes--full h3 {
  margin: 16px 0 8px;
  color: var(--bw-ink);
  font-size: 21px;
  line-height: 1.12;
  letter-spacing: -0.04em;
}

.bw-photo-editor__cover-card h3,
.bw-photo-editor__notes--full h3 {
  margin-top: 0;
}

.bw-photo-editor__profile-photo-card p,
.bw-photo-editor__cover-card p {
  margin: 0 0 18px;
  color: var(--bw-muted);
  font-size: 14px;
  line-height: 1.65;
}

.bw-photo-editor__profile-photo {
  position: relative;
  width: min(100%, 190px);
  aspect-ratio: 4 / 5;
  border-radius: 28px;
  overflow: visible;
  background: #EFF0EC;
  border: 6px solid #FFFFFF;
  box-shadow: 0 14px 30px rgba(16, 39, 31, 0.10);
  display: grid;
  place-items: center;
  color: var(--bw-muted);
  font-size: 13px;
}

.bw-photo-editor__profile-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 22px;
  display: block;
}

.bw-photo-editor__profile-photo-cta {
  position: absolute;
  right: -10px;
  bottom: -10px;
  width: 46px;
  height: 46px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.65);
  color: #FFFFFF;
  background: var(--bw-green);
  box-shadow: 0 12px 22px rgba(92, 130, 108, 0.24);
  font-size: 18px;
  font-weight: 800;
}

.bw-photo-editor__cover-card .bw-photo-editor__cover {
  min-height: 230px;
}

.bw-photo-editor__notes--full {
  margin-top: 24px;
}

.bw-photo-editor__notes--full p {
  margin: 0;
  color: var(--bw-muted);
  font-size: 14px;
  line-height: 1.7;
}

.bw-photo-modal__panel--card {
  width: min(820px, 100%);
}

.bw-photo-modal__steps--card {
  grid-template-columns: repeat(3, 1fr);
}

.bw-photo-modal__body--mode-card.bw-photo-modal__body--card {
  padding-top: 20px;
}

.bw-card-crop-layout--card {
  grid-template-columns: minmax(0, 1fr) 240px;
}

.bw-photo-modal__review-grid--card-only {
  grid-template-columns: minmax(220px, 280px);
  justify-content: center;
}

.bw-photo-modal__review-grid--card-only .bw-review-card {
  aspect-ratio: 4 / 5;
}

@media (max-width: 900px) {

  .bw-photo-editor__two-areas,
  .bw-card-crop-layout,
  .bw-card-crop-layout--card {
    grid-template-columns: 1fr;
  }

  .bw-cropper-shell--card {
    justify-self: center;
  }

  .bw-photo-editor__profile-photo {
    width: min(190px, 70vw);
  }
}


.bw-photo-modal__steps {
  display: none;
}

.bw-photo-modal__panel {
  width: min(900px, 100%);
  max-height: min(790px, calc(100vh - 48px));
}

.bw-photo-modal__panel--card {
  width: min(760px, 100%);
}

.bw-photo-modal__body {
  padding: 30px 28px 18px;
}

.bw-photo-modal__body--upload {
  padding: 24px;
}

.bw-photo-modal__upload-panel {
  min-height: 360px;
  gap: 24px;
  padding: 34px;
}

.bw-photo-modal__step-copy {
  margin-bottom: 18px;
}

.bw-photo-modal__step-copy--compact {
  margin-bottom: 16px;
}

.bw-photo-modal__step-copy h3,
.bw-photo-modal__upload-panel h3 {
  font-size: clamp(25px, 2.4vw, 32px);
}

.bw-photo-modal__step-copy span,
.bw-photo-modal__upload-panel span {
  font-size: 15px;
  line-height: 1.58;
}

.bw-cropper-shell--profile {
  width: min(100%, 820px);
}

.bw-card-crop-layout,
.bw-card-crop-layout--card {
  grid-template-columns: minmax(0, 1fr) 235px;
  align-items: center;
  gap: 22px;
}

.bw-cropper-shell--card {
  width: 235px;
  justify-self: end;
}

.bw-card-crop-note {
  justify-content: center;
  min-height: 230px;
  background: var(--bw-card);
}

.bw-photo-modal__review-grid--cover-only {
  grid-template-columns: minmax(0, 720px);
  justify-content: center;
}

.bw-photo-modal__footer {
  padding: 12px 28px 14px;
}

.bw-photo-modal__footer--card {
  justify-content: space-between;
}

@media (max-height: 900px) and (min-width: 761px) {
  .bw-photo-modal__panel {
    max-height: calc(100vh - 50px);
  }

  .bw-photo-modal__body {
    padding-top: 24px;
    padding-bottom: 14px;
  }

  .bw-photo-modal__upload-panel {
    min-height: 330px;
  }

  .bw-cropper-shell--profile {
    width: min(100%, 790px);
  }

  .bw-card-crop-layout,
  .bw-card-crop-layout--card {
    grid-template-columns: minmax(0, 1fr) 220px;
  }

  .bw-cropper-shell--card {
    width: 220px;
  }
}

@media (max-width: 760px) {

  .bw-card-crop-layout,
  .bw-card-crop-layout--card {
    grid-template-columns: 1fr;
  }

  .bw-cropper-shell--card {
    width: min(340px, 100%);
    justify-self: center;
  }

  .bw-card-crop-note {
    min-height: 0;
  }

  .bw-photo-modal__upload-panel {
    min-height: 400px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ProfessionalPhotoEditor/professional-photo-editor.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;EACnC,iBAAiB;EACjB,kCAAkC;EAClC,oBAAoB;EACpB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;;;;EAIE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,kCAAkC;EAClC,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,iCAAiC;EACjC,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,qCAAqC;EACrC,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB;;WAES;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,wCAAwC;EACxC,oBAAoB;EACpB,qCAAqC;EACrC,0BAA0B;EAC1B,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,qEAAqE;EACrE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;EAC3C,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;;EAEE;;;;IAIE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB;;6BAE2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;;;;CAIC;AACD;;EAEE,4BAA4B;AAC9B;;AAEA;yGACyG;AACzG;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;;;CAIC;AACD;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mCAAmC;EACnC,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,uGAAuG;AACzG;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,6BAA6B;EAC7B,iDAAiD;AACnD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;;;EAGE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;;AAEA;;EAEE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,qCAAqC;IACrC,4BAA4B;EAC9B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,oBAAoB;IACpB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;;AAGA;EACE;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA,mDAAmD;AACnD;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;IAEE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;EAGE,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;AACf;;AAEA;;;EAGE,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,2BAA2B;EAC3B,gDAAgD;EAChD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE;;;IAGE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;AACF;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;;EAEE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2CAA2C;EAC3C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;IAEE,2CAA2C;EAC7C;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;;EAEE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[":root {\n  --bw-green: #82B194;\n  --bw-green-hover: #739F84;\n  --bw-green-dark: #5C826C;\n  --bw-card: #F7F5F1;\n  --bw-card-soft: #F8F6F2;\n  --bw-page: #EFF0EC;\n  --bw-surface: #F7F5F1;\n  --bw-border: rgba(16, 25, 21, 0.10);\n  --bw-ink: #13231D;\n  --bw-muted: rgba(19, 35, 29, 0.68);\n  --bw-radius-lg: 28px;\n  --bw-radius-md: 18px;\n  --bw-shadow: 0 22px 60px rgba(16, 39, 31, 0.18);\n}\n\n.bw-photo-editor,\n.bw-photo-editor *,\n.bw-photo-modal,\n.bw-photo-modal * {\n  box-sizing: border-box;\n  font-style: normal;\n}\n\n.bw-photo-editor__shell {\n  background: var(--bw-card-soft);\n  border: 1px solid var(--bw-border);\n  border-radius: var(--bw-radius-lg);\n  box-shadow: 0 18px 48px rgba(16, 39, 31, 0.08);\n  padding: clamp(18px, 3vw, 32px);\n}\n\n.bw-photo-editor__header {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  align-items: flex-start;\n  margin-bottom: 18px;\n}\n\n.bw-photo-editor__eyebrow,\n.bw-photo-modal__eyebrow {\n  margin: 0 0 6px;\n  color: var(--bw-green);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n}\n\n.bw-photo-editor__header h2 {\n  margin: 0;\n  font-size: clamp(28px, 4vw, 44px);\n  line-height: 1;\n  letter-spacing: -0.05em;\n}\n\n.bw-photo-editor__saved {\n  border: 1px solid rgba(130, 177, 148, 0.30);\n  color: var(--bw-green-dark);\n  background: rgba(130, 177, 148, 0.12);\n  padding: 8px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.bw-photo-editor__cover {\n  position: relative;\n  overflow: hidden;\n  aspect-ratio: 16 / 7;\n  border-radius: 28px;\n  border: 1px solid var(--bw-border);\n  background: #EFF0EC;\n  min-height: 240px;\n}\n\n.bw-photo-editor__cover img,\n.bw-photo-editor__placeholder,\n.bw-review-profile img,\n.bw-review-card img,\n.bw-photo-editor__card-frame img {\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.bw-photo-editor__placeholder {\n  display: grid;\n  place-items: center;\n  color: var(--bw-muted);\n  background:\n    radial-gradient(circle at center, rgba(130, 177, 148, 0.14), transparent 45%),\n    #EFF0EC;\n}\n\n.bw-photo-editor__cover-cta {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border: 1px solid rgba(16, 39, 31, 0.15);\n  color: var(--bw-ink);\n  background: rgba(255, 255, 255, 0.78);\n  backdrop-filter: blur(8px);\n  border-radius: 999px;\n  min-height: 44px;\n  padding: 0 18px;\n  font-size: 14px;\n  font-weight: 800;\n  box-shadow: 0 14px 28px rgba(16, 39, 31, 0.12);\n}\n\n.bw-photo-editor__content-grid {\n  display: grid;\n  grid-template-columns: 1fr minmax(220px, 280px);\n  gap: 18px;\n  margin-top: 18px;\n}\n\n.bw-photo-editor__card-preview,\n.bw-photo-editor__notes {\n  background: var(--bw-card);\n  border: 1px solid var(--bw-border);\n  border-radius: 22px;\n  padding: 18px;\n}\n\n.bw-photo-editor__card-preview h3,\n.bw-photo-editor__notes h3 {\n  margin: 0 0 12px;\n  font-size: 16px;\n}\n\n.bw-photo-editor__card-frame {\n  width: min(180px, 100%);\n  aspect-ratio: 4 / 5;\n  border-radius: 18px;\n  overflow: hidden;\n  border: 1px solid var(--bw-border);\n  background: #EFF0EC;\n  display: grid;\n  place-items: center;\n  color: var(--bw-muted);\n  font-size: 13px;\n}\n\n.bw-photo-editor__notes p {\n  margin: 0;\n  color: var(--bw-muted);\n  line-height: 1.65;\n  font-size: 14px;\n}\n\n.bw-photo-editor__notes code {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n  background: rgba(130, 177, 148, 0.12);\n  padding: 2px 5px;\n  border-radius: 6px;\n  color: var(--bw-green-dark);\n}\n\n.bw-photo-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n}\n\n.bw-photo-modal__backdrop {\n  position: absolute;\n  inset: 0;\n  background: rgba(16, 39, 31, 0.48);\n}\n\n.bw-photo-modal__panel {\n  position: relative;\n  width: min(960px, 100%);\n  max-height: min(828px, calc(100vh - 48px));\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  border-radius: 30px;\n  background: var(--bw-card-soft);\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  box-shadow: var(--bw-shadow);\n}\n\n.bw-photo-modal__close {\n  position: absolute;\n  top: 16px;\n  right: 18px;\n  z-index: 4;\n  min-height: 38px;\n  padding: 0 15px;\n  border-radius: 16px;\n  border: 1px solid rgba(16, 39, 31, 0.13);\n  background: rgba(255, 255, 255, 0.72);\n  color: var(--bw-ink);\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.bw-photo-modal__steps {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  list-style: none;\n  margin: 0;\n  padding: 18px 116px 12px 24px;\n  border-bottom: 1px solid rgba(16, 39, 31, 0.08);\n}\n\n.bw-photo-modal__steps li {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  color: rgba(16, 39, 31, 0.56);\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n}\n\n.bw-photo-modal__steps span {\n  width: 24px;\n  height: 24px;\n  flex: 0 0 24px;\n  display: grid;\n  place-items: center;\n  border-radius: 999px;\n  background: rgba(16, 39, 31, 0.08);\n  color: rgba(16, 39, 31, 0.64);\n  font-size: 11px;\n}\n\n.bw-photo-modal__steps li.is-active {\n  color: var(--bw-green-dark);\n}\n\n.bw-photo-modal__steps li.is-active span {\n  background: var(--bw-green);\n  color: #fff;\n}\n\n.bw-photo-modal__body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 18px 24px 12px;\n}\n\n@media (min-width: 761px) {\n\n  .bw-photo-modal__body--upload,\n  .bw-photo-modal__body--profile,\n  .bw-photo-modal__body--card,\n  .bw-photo-modal__body--review {\n    overflow: hidden;\n  }\n}\n\n.bw-photo-modal__step-copy {\n  max-width: 820px;\n  padding-right: 118px;\n  margin-bottom: 14px;\n}\n\n.bw-photo-modal__step-copy--compact {\n  margin-bottom: 12px;\n}\n\n.bw-photo-modal__step-copy p {\n  margin: 0 0 6px;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  font-size: 12px;\n  font-weight: 800;\n  color: var(--bw-green);\n}\n\n.bw-photo-modal__step-copy h3,\n.bw-photo-modal__upload-panel h3 {\n  margin: 0 0 8px;\n  font-size: clamp(24px, 3vw, 32px);\n  line-height: 1.02;\n  letter-spacing: -0.05em;\n}\n\n.bw-photo-modal__step-copy span,\n.bw-photo-modal__upload-panel span {\n  display: block;\n  color: var(--bw-muted);\n  font-size: 16px;\n  line-height: 1.45;\n}\n\n.bw-photo-modal__step-copy span {\n  max-width: 760px;\n}\n\n.bw-photo-modal__upload-panel span {\n  max-width: 620px;\n  margin: 0 auto;\n}\n\n.bw-photo-modal__upload-panel {\n  min-height: 360px;\n  display: grid;\n  place-items: center;\n  gap: 22px;\n  text-align: center;\n  padding: 28px;\n  border: 1px dashed rgba(16, 39, 31, 0.18);\n  border-radius: 24px;\n  background:\n    radial-gradient(circle at center, rgba(130, 177, 148, 0.14), transparent 48%),\n    rgba(255, 255, 255, 0.36);\n}\n\n.bw-cropper-shell {\n  position: relative;\n  width: 100%;\n  border-radius: 24px;\n  overflow: hidden;\n  background: var(--bw-ink, #13231D);\n  border: 1px solid rgba(16, 39, 31, 0.12);\n}\n\n.bw-cropper-shell--profile {\n  width: min(100%, 900px);\n  margin: 0 auto;\n  aspect-ratio: 16 / 7;\n  min-height: 0;\n}\n\n.bw-card-crop-layout {\n  display: grid;\n  grid-template-columns: 1fr 250px;\n  gap: 18px;\n  align-items: stretch;\n}\n\n.bw-cropper-shell--card {\n  width: 250px;\n  justify-self: end;\n  aspect-ratio: 4 / 5;\n  min-height: 0;\n}\n\n.bw-card-crop-note {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 8px;\n  min-height: 0;\n  padding: 20px;\n  border-radius: 22px;\n  border: 1px solid rgba(16, 39, 31, 0.1);\n  background: var(--bw-card);\n}\n\n.bw-card-crop-note strong {\n  color: var(--bw-green-dark);\n  font-size: 15px;\n}\n\n.bw-card-crop-note p {\n  margin: 0;\n  max-width: 420px;\n  color: var(--bw-muted);\n  font-size: 14px;\n  line-height: 1.55;\n}\n\n.bw-link-btn {\n  width: fit-content;\n  margin-top: 4px;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--bw-green-dark);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 800;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n/*\n  Clave de implementación:\n  react-easy-crop debe trabajar en modo cover. Si en staging se ve la foto centrada con laterales vacíos,\n  revisar si el componente quedó con objectFit=\"contain\" o si el contenedor/previews usan object-fit: contain.\n*/\n.bw-cropper-shell .reactEasyCrop_Image,\n.bw-cropper-shell .reactEasyCrop_Video {\n  object-fit: cover !important;\n}\n\n/* Ajuste v14: el área de recorte coincide con el contenedor.\n   Se oculta el borde interno de react-easy-crop para evitar una línea lateral que parece error visual. */\n.bw-cropper-shell .reactEasyCrop_CropArea {\n  border: 0 !important;\n  box-shadow: none !important;\n  color: transparent !important;\n}\n\n.bw-cropper-shell .reactEasyCrop_Container {\n  border-radius: inherit;\n  overflow: hidden;\n}\n\n.bw-photo-modal__slider {\n  display: grid;\n  gap: 5px;\n  margin: 10px 0 0;\n  color: var(--bw-ink);\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1;\n  text-align: center;\n}\n\n.bw-photo-modal__slider--card {\n  margin-top: 8px;\n}\n\n.bw-photo-modal__slider span {\n  display: block;\n  line-height: 1;\n}\n\n/*\n  Slider de zoom:\n  El control debe usar verde primary #82B194 y nunca el azul nativo del navegador.\n  No se dibuja progreso con linear-gradient para evitar una segunda barra visual.\n*/\n.bw-photo-modal__slider input {\n  width: 100%;\n  height: 22px;\n  appearance: none;\n  -webkit-appearance: none;\n  border-radius: 999px;\n  background: transparent;\n  outline: none;\n  accent-color: var(--bw-green);\n  cursor: pointer;\n}\n\n.bw-photo-modal__slider input::-webkit-slider-runnable-track {\n  height: 5px;\n  border-radius: 999px;\n  background: rgba(130, 177, 148, 0.34);\n  border: 1px solid rgba(130, 177, 148, 0.24);\n}\n\n.bw-photo-modal__slider input::-webkit-slider-thumb {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 16px;\n  height: 16px;\n  margin-top: -6.5px;\n  border-radius: 999px;\n  border: 2px solid var(--bw-surface);\n  background: var(--bw-green);\n  box-shadow: 0 6px 14px rgba(19, 35, 29, 0.18);\n}\n\n.bw-photo-modal__slider input::-moz-range-track {\n  height: 5px;\n  border-radius: 999px;\n  background: rgba(130, 177, 148, 0.34);\n  border: 1px solid rgba(130, 177, 148, 0.24);\n}\n\n.bw-photo-modal__slider input::-moz-range-progress {\n  height: 5px;\n  border-radius: 999px;\n  background: rgba(130, 177, 148, 0.34);\n}\n\n.bw-photo-modal__slider input::-moz-range-thumb {\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  border: 2px solid var(--bw-surface);\n  background: var(--bw-green);\n  box-shadow: 0 6px 14px rgba(19, 35, 29, 0.18);\n}\n\n.bw-photo-modal__slider input:focus-visible::-webkit-slider-thumb {\n  outline: 3px solid rgba(130, 177, 148, 0.28);\n  outline-offset: 2px;\n}\n\n.bw-photo-modal__slider input:focus-visible::-moz-range-thumb {\n  outline: 3px solid rgba(130, 177, 148, 0.28);\n  outline-offset: 2px;\n}\n\n.bw-photo-modal__review-grid {\n  display: grid;\n  grid-template-columns: 1.25fr 0.75fr;\n  gap: 18px;\n  align-items: start;\n}\n\n.bw-photo-modal__review-grid article {\n  background: var(--bw-card);\n  border: 1px solid var(--bw-border);\n  border-radius: 22px;\n  padding: 16px;\n}\n\n.bw-photo-modal__review-grid h4 {\n  margin: 0 0 12px;\n  font-size: 14px;\n  text-align: center;\n}\n\n.bw-review-profile,\n.bw-review-card {\n  overflow: hidden;\n  border-radius: 16px;\n  background: #EFF0EC;\n  border: 1px solid var(--bw-border);\n}\n\n.bw-review-profile {\n  aspect-ratio: 16 / 7;\n}\n\n.bw-review-card {\n  width: min(230px, 100%);\n  margin: 0 auto;\n  aspect-ratio: 4 / 5;\n}\n\n.bw-photo-modal__error {\n  margin: 10px 0 0;\n  color: #8d332b;\n  background: rgba(141, 51, 43, 0.08);\n  border: 1px solid rgba(141, 51, 43, 0.18);\n  padding: 10px 12px;\n  border-radius: 14px;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.bw-photo-modal__footer {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 24px 12px;\n  border-top: 1px solid rgba(16, 39, 31, 0.08);\n  background: rgba(248, 246, 242, 0.94);\n}\n\n.bw-photo-modal__footer--card {\n  justify-content: space-between;\n}\n\n.bw-btn {\n  min-height: 44px;\n  border-radius: 16px;\n  padding: 0 20px;\n  border: 1px solid transparent;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 800;\n  white-space: nowrap;\n  appearance: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease;\n}\n\n.bw-btn:active {\n  transform: translateY(1px);\n}\n\n.bw-btn--primary {\n  color: #fff;\n  background: var(--bw-green);\n  border-color: var(--bw-green);\n  box-shadow: 0 12px 20px rgba(130, 177, 148, 0.24);\n}\n\n.bw-btn--primary:hover {\n  background: var(--bw-green-hover);\n}\n\n.bw-btn--primary:disabled {\n  opacity: 0.65;\n  cursor: wait;\n}\n\n.bw-btn--secondary {\n  color: var(--bw-ink);\n  background: rgba(255, 255, 255, 0.72);\n  border-color: rgba(16, 39, 31, 0.14);\n  box-shadow: 0 8px 18px rgba(16, 39, 31, 0.05);\n}\n\n.bw-btn--secondary:hover {\n  background: rgba(255, 255, 255, 0.92);\n  border-color: rgba(130, 177, 148, 0.36);\n}\n\n.bw-btn:focus-visible,\n.bw-photo-modal__close:focus-visible,\n.bw-photo-editor__cover-cta:focus-visible {\n  outline: 3px solid rgba(130, 177, 148, 0.32);\n  outline-offset: 2px;\n}\n\n@media (max-height: 900px) and (min-width: 761px) {\n  .bw-photo-modal__panel {\n    max-height: calc(100vh - 48px);\n  }\n\n  .bw-photo-modal__steps {\n    padding-top: 14px;\n    padding-bottom: 10px;\n  }\n\n  .bw-photo-modal__body {\n    padding-top: 16px;\n    padding-bottom: 12px;\n  }\n\n  .bw-cropper-shell--profile {\n    width: min(100%, 860px);\n  }\n\n  .bw-card-crop-layout {\n    grid-template-columns: 1fr 230px;\n  }\n\n  .bw-cropper-shell--card {\n    width: 230px;\n  }\n\n  .bw-photo-modal__footer {\n    padding-top: 12px;\n    padding-bottom: 14px;\n  }\n}\n\n@media (max-width: 760px) {\n\n  .bw-photo-editor__content-grid,\n  .bw-photo-modal__review-grid,\n  .bw-card-crop-layout {\n    grid-template-columns: 1fr;\n  }\n\n  .bw-photo-editor__cover {\n    min-height: 180px;\n    border-radius: 22px;\n  }\n\n  .bw-photo-modal {\n    padding: 10px;\n    align-items: stretch;\n  }\n\n  .bw-photo-modal__panel {\n    max-height: calc(100vh - 20px);\n    border-radius: 24px;\n  }\n\n  .bw-photo-modal__steps {\n    grid-template-columns: repeat(2, 1fr);\n    padding: 14px 82px 12px 14px;\n  }\n\n  .bw-photo-modal__steps li {\n    font-size: 11px;\n  }\n\n  .bw-photo-modal__body {\n    overflow-y: auto;\n    padding: 18px 14px 14px;\n  }\n\n  .bw-photo-modal__close {\n    top: 12px;\n    right: 12px;\n    min-height: 40px;\n    padding: 0 14px;\n  }\n\n  .bw-photo-modal__step-copy {\n    padding-right: 0;\n  }\n\n  .bw-photo-modal__step-copy span,\n  .bw-photo-modal__upload-panel span {\n    font-size: 15px;\n  }\n\n  .bw-photo-modal__upload-panel {\n    min-height: 420px;\n    padding: 22px;\n  }\n\n  .bw-cropper-shell--profile {\n    width: 100%;\n    aspect-ratio: 16 / 7;\n    min-height: 0;\n    border-radius: 18px;\n  }\n\n  .bw-cropper-shell--card {\n    width: min(360px, 100%);\n    margin: 0 auto;\n    max-height: none;\n    border-radius: 22px;\n  }\n\n  .bw-card-crop-note {\n    padding: 14px;\n  }\n\n  .bw-photo-modal__slider {\n    margin-top: 18px;\n    margin-bottom: 8px;\n    gap: 12px;\n  }\n\n  .bw-photo-modal__slider input {\n    min-height: 32px;\n  }\n\n  .bw-photo-modal__footer {\n    flex-direction: column;\n    padding: 14px;\n  }\n\n  .bw-photo-modal__footer .bw-btn {\n    width: 100%;\n  }\n\n  .bw-photo-modal__footer--card .bw-btn:nth-child(1) {\n    order: 1;\n  }\n\n  .bw-photo-modal__footer--card .bw-btn:nth-child(2) {\n    order: 2;\n  }\n\n  .bw-photo-modal__footer--card .bw-btn:nth-child(3) {\n    order: 3;\n  }\n}\n\n\n@media (min-width: 761px) {\n  .bw-photo-editor__notes {\n    order: 1;\n  }\n\n  .bw-photo-editor__card-preview {\n    order: 2;\n  }\n}\n\n/* v7 · Ajuste de lectura y respiración del popup */\n.bw-photo-modal__panel {\n  width: min(980px, 100%);\n  max-height: min(820px, calc(100vh - 48px));\n  background: var(--bw-card-soft);\n}\n\n.bw-photo-modal__body {\n  padding: 30px 28px 18px;\n}\n\n.bw-photo-modal__body--upload {\n  padding: 22px;\n}\n\n.bw-photo-modal__step-copy {\n  max-width: 780px;\n  padding-right: 124px;\n  margin-bottom: 22px;\n}\n\n.bw-photo-modal__step-copy--compact {\n  margin-bottom: 18px;\n}\n\n.bw-photo-modal__step-copy p {\n  margin-bottom: 8px;\n  color: var(--bw-green);\n}\n\n.bw-photo-modal__step-copy h3,\n.bw-photo-modal__upload-panel h3 {\n  margin-bottom: 12px;\n  font-size: clamp(26px, 2.6vw, 34px);\n  line-height: 1.06;\n}\n\n.bw-photo-modal__step-copy span,\n.bw-photo-modal__upload-panel span {\n  max-width: 720px;\n  font-size: 15px;\n  line-height: 1.65;\n}\n\n.bw-photo-modal__upload-panel {\n  min-height: 430px;\n  gap: 30px;\n  padding: 34px 36px;\n}\n\n.bw-photo-modal__upload-panel span {\n  max-width: 680px;\n}\n\n.bw-cropper-shell--profile {\n  width: min(100%, 840px);\n}\n\n.bw-card-crop-layout {\n  grid-template-columns: minmax(0, 1fr) 225px;\n  gap: 22px;\n  align-items: center;\n}\n\n.bw-cropper-shell--card {\n  width: 225px;\n}\n\n.bw-card-crop-note {\n  justify-content: center;\n  padding: 22px 24px;\n}\n\n.bw-card-crop-note p {\n  max-width: 500px;\n  line-height: 1.65;\n}\n\n.bw-photo-modal__slider {\n  margin-top: 16px;\n  gap: 10px;\n}\n\n.bw-photo-modal__slider--card {\n  margin-top: 14px;\n}\n\n.bw-photo-modal__footer {\n  padding: 12px 28px 14px;\n}\n\n@media (max-height: 900px) and (min-width: 761px) {\n  .bw-photo-modal__body {\n    padding-top: 24px;\n    padding-bottom: 14px;\n  }\n\n  .bw-photo-modal__step-copy {\n    margin-bottom: 18px;\n  }\n\n  .bw-photo-modal__step-copy h3,\n  .bw-photo-modal__upload-panel h3 {\n    font-size: 29px;\n  }\n\n  .bw-photo-modal__step-copy span,\n  .bw-photo-modal__upload-panel span {\n    font-size: 14.5px;\n    line-height: 1.58;\n  }\n\n  .bw-cropper-shell--profile {\n    width: min(100%, 820px);\n  }\n\n  .bw-card-crop-layout {\n    grid-template-columns: minmax(0, 1fr) 215px;\n  }\n\n  .bw-cropper-shell--card {\n    width: 215px;\n  }\n\n  .bw-photo-modal__slider {\n    margin-top: 12px;\n  }\n}\n\n@media (max-width: 760px) {\n\n  .bw-photo-modal__body,\n  .bw-photo-modal__body--upload {\n    padding: 18px 14px 14px;\n  }\n\n  .bw-photo-modal__step-copy {\n    padding-right: 0;\n    margin-bottom: 18px;\n  }\n\n  .bw-photo-modal__step-copy h3,\n  .bw-photo-modal__upload-panel h3 {\n    font-size: 25px;\n  }\n\n  .bw-photo-modal__step-copy span,\n  .bw-photo-modal__upload-panel span {\n    font-size: 15px;\n    line-height: 1.55;\n  }\n\n  .bw-card-crop-layout {\n    gap: 14px;\n  }\n}\n\n/* v11 · Dos modos de entrada: portada pública y foto/tarjeta */\n.bw-photo-editor__two-areas {\n  display: grid;\n  grid-template-columns: 250px minmax(0, 1fr);\n  gap: 24px;\n  align-items: start;\n}\n\n.bw-photo-editor__profile-photo-card,\n.bw-photo-editor__cover-card,\n.bw-photo-editor__notes--full {\n  background: var(--bw-card);\n  border: 1px solid var(--bw-border);\n  border-radius: 28px;\n  padding: 22px;\n}\n\n.bw-photo-editor__profile-photo-card h3,\n.bw-photo-editor__cover-card h3,\n.bw-photo-editor__notes--full h3 {\n  margin: 16px 0 8px;\n  color: var(--bw-ink);\n  font-size: 21px;\n  line-height: 1.12;\n  letter-spacing: -0.04em;\n}\n\n.bw-photo-editor__cover-card h3,\n.bw-photo-editor__notes--full h3 {\n  margin-top: 0;\n}\n\n.bw-photo-editor__profile-photo-card p,\n.bw-photo-editor__cover-card p {\n  margin: 0 0 18px;\n  color: var(--bw-muted);\n  font-size: 14px;\n  line-height: 1.65;\n}\n\n.bw-photo-editor__profile-photo {\n  position: relative;\n  width: min(100%, 190px);\n  aspect-ratio: 4 / 5;\n  border-radius: 28px;\n  overflow: visible;\n  background: #EFF0EC;\n  border: 6px solid #FFFFFF;\n  box-shadow: 0 14px 30px rgba(16, 39, 31, 0.10);\n  display: grid;\n  place-items: center;\n  color: var(--bw-muted);\n  font-size: 13px;\n}\n\n.bw-photo-editor__profile-photo img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 22px;\n  display: block;\n}\n\n.bw-photo-editor__profile-photo-cta {\n  position: absolute;\n  right: -10px;\n  bottom: -10px;\n  width: 46px;\n  height: 46px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.65);\n  color: #FFFFFF;\n  background: var(--bw-green);\n  box-shadow: 0 12px 22px rgba(92, 130, 108, 0.24);\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.bw-photo-editor__cover-card .bw-photo-editor__cover {\n  min-height: 230px;\n}\n\n.bw-photo-editor__notes--full {\n  margin-top: 24px;\n}\n\n.bw-photo-editor__notes--full p {\n  margin: 0;\n  color: var(--bw-muted);\n  font-size: 14px;\n  line-height: 1.7;\n}\n\n.bw-photo-modal__panel--card {\n  width: min(820px, 100%);\n}\n\n.bw-photo-modal__steps--card {\n  grid-template-columns: repeat(3, 1fr);\n}\n\n.bw-photo-modal__body--mode-card.bw-photo-modal__body--card {\n  padding-top: 20px;\n}\n\n.bw-card-crop-layout--card {\n  grid-template-columns: minmax(0, 1fr) 240px;\n}\n\n.bw-photo-modal__review-grid--card-only {\n  grid-template-columns: minmax(220px, 280px);\n  justify-content: center;\n}\n\n.bw-photo-modal__review-grid--card-only .bw-review-card {\n  aspect-ratio: 4 / 5;\n}\n\n@media (max-width: 900px) {\n\n  .bw-photo-editor__two-areas,\n  .bw-card-crop-layout,\n  .bw-card-crop-layout--card {\n    grid-template-columns: 1fr;\n  }\n\n  .bw-cropper-shell--card {\n    justify-self: center;\n  }\n\n  .bw-photo-editor__profile-photo {\n    width: min(190px, 70vw);\n  }\n}\n\n\n.bw-photo-modal__steps {\n  display: none;\n}\n\n.bw-photo-modal__panel {\n  width: min(900px, 100%);\n  max-height: min(790px, calc(100vh - 48px));\n}\n\n.bw-photo-modal__panel--card {\n  width: min(760px, 100%);\n}\n\n.bw-photo-modal__body {\n  padding: 30px 28px 18px;\n}\n\n.bw-photo-modal__body--upload {\n  padding: 24px;\n}\n\n.bw-photo-modal__upload-panel {\n  min-height: 360px;\n  gap: 24px;\n  padding: 34px;\n}\n\n.bw-photo-modal__step-copy {\n  margin-bottom: 18px;\n}\n\n.bw-photo-modal__step-copy--compact {\n  margin-bottom: 16px;\n}\n\n.bw-photo-modal__step-copy h3,\n.bw-photo-modal__upload-panel h3 {\n  font-size: clamp(25px, 2.4vw, 32px);\n}\n\n.bw-photo-modal__step-copy span,\n.bw-photo-modal__upload-panel span {\n  font-size: 15px;\n  line-height: 1.58;\n}\n\n.bw-cropper-shell--profile {\n  width: min(100%, 820px);\n}\n\n.bw-card-crop-layout,\n.bw-card-crop-layout--card {\n  grid-template-columns: minmax(0, 1fr) 235px;\n  align-items: center;\n  gap: 22px;\n}\n\n.bw-cropper-shell--card {\n  width: 235px;\n  justify-self: end;\n}\n\n.bw-card-crop-note {\n  justify-content: center;\n  min-height: 230px;\n  background: var(--bw-card);\n}\n\n.bw-photo-modal__review-grid--cover-only {\n  grid-template-columns: minmax(0, 720px);\n  justify-content: center;\n}\n\n.bw-photo-modal__footer {\n  padding: 12px 28px 14px;\n}\n\n.bw-photo-modal__footer--card {\n  justify-content: space-between;\n}\n\n@media (max-height: 900px) and (min-width: 761px) {\n  .bw-photo-modal__panel {\n    max-height: calc(100vh - 50px);\n  }\n\n  .bw-photo-modal__body {\n    padding-top: 24px;\n    padding-bottom: 14px;\n  }\n\n  .bw-photo-modal__upload-panel {\n    min-height: 330px;\n  }\n\n  .bw-cropper-shell--profile {\n    width: min(100%, 790px);\n  }\n\n  .bw-card-crop-layout,\n  .bw-card-crop-layout--card {\n    grid-template-columns: minmax(0, 1fr) 220px;\n  }\n\n  .bw-cropper-shell--card {\n    width: 220px;\n  }\n}\n\n@media (max-width: 760px) {\n\n  .bw-card-crop-layout,\n  .bw-card-crop-layout--card {\n    grid-template-columns: 1fr;\n  }\n\n  .bw-cropper-shell--card {\n    width: min(340px, 100%);\n    justify-self: center;\n  }\n\n  .bw-card-crop-note {\n    min-height: 0;\n  }\n\n  .bw-photo-modal__upload-panel {\n    min-height: 400px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
